module.exports = __webpack_public_path__ + "img/sack-dollar.49f20762.svg";